import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the measurementDetails state domain
 */

const selectMeasurementDetailsDomain = (state) =>
  state.get("measurementDetails", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectDimensions = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("dimensions")
  )

export const makeSelectMetricTotal = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("metric_total")
  )

export const makeSelectIsLoadingStatus = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingStatus")
  )

export const makeSelectMeasureClimate = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("measureStatus")
  )

export const makeSelectIsLoadingDivisionsMeasure = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingDivisionsMeasure")
  )

export const makeSelectDivisionsMeasure = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("divisionsMeasure")
  )

export const makeSelectDivisionsMeasureMeta = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("divisionsMeasureMeta")
  )

export const makeSelectIsLoadingDivisionsTreeMeasure = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingDivisionsTreeMeasure")
  )

export const makeSelectDivisionsTreeMeasure = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("divisionsTreeMeasure")
  )

export const makeSelectQualitativeQuestions = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("qualitativeQuestions")
  )

export const makeSelectIsLoadingQualitative = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingQualitativeQuestions")
  )

export const makeSelectProgDates = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("progDates")
  )

export const makeSelectIsLoadingDates = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingDates")
  )

export const makeSelectCountCollaborators = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("countCollaborators")
  )

export const makeSelectIsLoadingRecipients = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingAddRecipients")
  )

export const makeSelectAddRecipients = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("addRecipients")
  )

export const makeSelectRecipientsSegments = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("recipientsSegments")
  )
export const makeSelectIsLoadingRecipientsSegments = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingRecipientsSegments")
  )
export const makeSelectIsLoadingDatesProgramming = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingDatesProgramming")
  )

export const makeSelectLeadersSegments = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("leadersSegments")
  )

export const makeSelectIsLoadingLeadersSegments = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingLeadersSegments")
  )

export const makeSelectDatesProgramming = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("datesProgramming")
  )

export const makeSelectIsLoadingSurveysType = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingSurveysType")
  )

export const makeSelectSurveysType = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("surveysType")
  )

export const makeSelectIsLoadingLeadersDetails = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingLeadersDetails")
  )

export const makeSelectLeadersDetails = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("leadersDetails")
  )

export const makeSelectLeadersDetailsMeta = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("leadersDetailsMeta")
  )

export const makeShowIncludeSubDivisions = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("show_include_subdivisions")
  )

export const makeSelectMeasureRangeColor = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("measureColorRange")
  )

export const makeSelectListPossibleRecipients = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("listPossibleRecipients")
  )

export const makeSelectIsLoadingAddCollaborators = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingAddCollaborators")
  )

export const makeSelectIsLoadingDimensionsRank = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("isLoadingDimensionsRank")
  )

export const makeSelectDimensionsRank = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("dimensionsRank")
  )

export const makeSelectMeasureEngagement = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("measureEngagement")
  )

export const makeSelectMeasureGeneral = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("measureGeneral")
  )

export const makeSelectMeasureTotal = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("measureTotal")
  )

export const makeSelectMeasureInfo = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("measureInfo")
  )

export const makeSelectDetailCounts = () =>
  createSelector(selectMeasurementDetailsDomain, (state) =>
    state.get("detailCounts")
  )

export const makeSelectIsLoadingDetailCounts = () => createSelector(selectMeasurementDetailsDomain, (state) => state.get("isLoadingDetailCounts"))

export const makeSelectMeasureRate = () => createSelector(selectMeasurementDetailsDomain, (state) => state.get("measureRate"))

export const makeSelectIsLoadingMeasureRate = () => createSelector(selectMeasurementDetailsDomain, (state) => state.get("isLoadingMeasureRate"))

/**
 * Default selector used by MeasurementDetails
 */

const makeSelectMeasurementDetails = () =>
  createSelector(selectMeasurementDetailsDomain, (substate) => substate.toJS())

export default makeSelectMeasurementDetails
export { selectMeasurementDetailsDomain }


